/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_TRACKS (state, tracks) {
    state.tracks = tracks
  },
  REMOVE_RECORD (state, itemId) {
    const trackIndex = state.tracks.findIndex((u) => u.TrackId === itemId)
    state.tracks.splice(trackIndex, 1)
  }
}
